/**
 * Logo Ticker
 * Infinite horizontal scroll animation for logo carousels
 */

(function() {
  'use strict';

  function initTicker(container) {
    const track = container.querySelector('.logo-ticker__track');
    const items = container.querySelector('.logo-ticker__items');
    if (!track || !items) return;

    const speed = parseInt(container.dataset.tickerSpeed) || 70;
    const reverse = container.dataset.tickerReverse === 'true';
    const pauseOnHover = container.dataset.tickerPause === 'true';

    // Clone container for seamless loop
    let clone = track.querySelector('.logo-ticker__items--clone');

    function calculateAndAnimate() {
      const trackWidth = track.parentElement.getBoundingClientRect().width;

      // Use getBoundingClientRect for accurate width
      const itemsWidth = items.getBoundingClientRect().width;

      // Get gap from items container (same gap used between individual items)
      const gap = parseInt(getComputedStyle(items).columnGap) || 16;

      if (!itemsWidth || !trackWidth) return;

      // Create clone if it doesn't exist
      if (!clone) {
        clone = document.createElement('div');
        clone.className = 'logo-ticker__items logo-ticker__items--clone';
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      }

      // Populate clone with same content
      clone.innerHTML = items.innerHTML;

      // Calculate animation duration based on content width and speed
      const totalWidth = itemsWidth + gap;
      const duration = totalWidth / speed;

      // Set CSS custom properties on track
      track.style.setProperty('--ticker-duration', `${duration}s`);
      track.style.setProperty('--ticker-direction', reverse ? 'reverse' : 'normal');
      track.style.setProperty('--ticker-width', `${totalWidth}px`);
      track.style.setProperty('--ticker-gap', `${gap}px`);
      track.style.setProperty('--ticker-pause-on-hover', pauseOnHover ? 'paused' : 'running');
    }

    // Initial calculation
    calculateAndAnimate();

    // Recalculate on resize
    const resizeObserver = new ResizeObserver(calculateAndAnimate);
    resizeObserver.observe(track.parentElement);
    resizeObserver.observe(items);
  }

  function init() {
    const tickers = document.querySelectorAll('[data-ticker]');
    tickers.forEach(initTicker);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize on Shopify section events (theme editor)
  document.addEventListener('shopify:section:load', (e) => {
    const ticker = e.target.querySelector('[data-ticker]');
    if (ticker) initTicker(ticker);
  });
})();
